var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("qr-codes")))]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("app-select-placement", {
                            attrs: {
                              "include-none": "",
                              "full-control": "",
                              layout: _vm.layout,
                              fancy: true,
                              value: _vm.clientPortalQrPlacement,
                              label: _vm.$ct("qr-code-to-client-portal"),
                            },
                            on: {
                              input: function ($event) {
                                return _vm.setClientPortalQrPlacement($event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("app-select-placement", {
                            attrs: {
                              "include-none": "",
                              "full-control": "",
                              layout: _vm.layout,
                              fancy: true,
                              value: _vm.paymentQrPlacement,
                              label: _vm.$ct("qr-payment-placement"),
                            },
                            on: {
                              input: function ($event) {
                                return _vm.setPaymentQrPlacement($event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("w-input", {
                            attrs: {
                              fancy: "",
                              label: _vm.$ct("receipient-name-in-app"),
                            },
                            model: {
                              value: _vm.paymentQrSettings.ReceipientName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.paymentQrSettings,
                                  "ReceipientName",
                                  $$v
                                )
                              },
                              expression: "paymentQrSettings.ReceipientName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("app-select-bank-type", {
                            attrs: {
                              "use-ids": "",
                              fancy: true,
                              "filter-only-with-iban": "",
                              label: _vm.$ct("qr-paymet-bank"),
                            },
                            model: {
                              value: _vm.paymentQrSettings.BankID,
                              callback: function ($$v) {
                                _vm.$set(_vm.paymentQrSettings, "BankID", $$v)
                              },
                              expression: "paymentQrSettings.BankID",
                            },
                          }),
                          _vm.showEmptyBankErrorMessage
                            ? _c(
                                "app-error-message-box",
                                {
                                  attrs: {
                                    hide: !_vm.showEmptyBankErrorMessage,
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$ct("qr-bank-has-no-iban-or-bic")
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        {
                          attrs: {
                            xs: "12",
                            md: _vm.isCustomReference ? 4 : 12,
                          },
                        },
                        [
                          _c("w-select", {
                            attrs: {
                              items: _vm.referenceTypeItems,
                              fancy: "",
                              label: _vm.$ct("qr-payment-reference-type"),
                            },
                            model: {
                              value: _vm.paymentQrSettings.ReferenceType,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.paymentQrSettings,
                                  "ReferenceType",
                                  $$v
                                )
                              },
                              expression: "paymentQrSettings.ReferenceType",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.isCustomReference
                        ? [
                            _c(
                              "w-col",
                              { attrs: { xs: "12", md: "4" } },
                              [
                                _c("app-custom-lang-select", {
                                  model: {
                                    value: _vm.customReferenceLang,
                                    callback: function ($$v) {
                                      _vm.customReferenceLang = $$v
                                    },
                                    expression: "customReferenceLang",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "w-col",
                              { attrs: { xs: "12", md: "4" } },
                              [
                                _c("w-input", {
                                  attrs: { fancy: "", label: _vm.$ct("text") },
                                  model: {
                                    value:
                                      _vm.paymentQrSettings.CustomReferenceText
                                        .Translations[_vm.customReferenceLang],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.paymentQrSettings
                                          .CustomReferenceText.Translations,
                                        _vm.customReferenceLang,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "paymentQrSettings.CustomReferenceText.Translations[customReferenceLang]",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "w-col",
                              { attrs: { xs: "12" } },
                              [
                                _c("app-prop-select-autocomplete", {
                                  attrs: {
                                    label: _vm.$ct("prop"),
                                    fancy: "",
                                    items: _vm.saleMapProps,
                                    "allow-empty": "",
                                  },
                                  model: {
                                    value:
                                      _vm.paymentQrSettings.CustomReferenceProp,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.paymentQrSettings,
                                        "CustomReferenceProp",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "paymentQrSettings.CustomReferenceProp",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                      _c(
                        "w-col",
                        { style: { alignItems: "start" }, attrs: { xs: "12" } },
                        [
                          _c(
                            "w-button",
                            {
                              staticClass: "mt",
                              style: { flexGrow: 0, flexShrink: 1 },
                              attrs: { disabled: _vm.paymentQrSettings.Show },
                              on: {
                                click: function ($event) {
                                  return _vm.addQrCode()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$ct("automations.titles.qr-code")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }